import OrganizationsTable from "./OrganizationsTable"

export default OrganizationsTable
